// PrintPage.jsx
import React from 'react';

const pageStyle = {
  width: '794px', // A4 width in pixels at 96 DPI
  height: '1123px', // A4 height
  border: '1px solid #ccc',
  backgroundColor: '#fff',
  boxShadow: '0 0 10px rgba(0,0,0,0.1)',
  padding: '20px',
  boxSizing: 'border-box',
};

export default function PrintPage({ children }) {
  return <div style={pageStyle}>{children}</div>;
}
